import React, { useState, useEffect, useContext } from "react";
import { Images } from "../../theme";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import {
  Header,
  RenderPagination,
  ProductCard,
  DotsLoader,
  NoDataFound,
  ProductGridCard,
  ProductLocationCard,
  Footer,
  LoginHeader,
} from "../../components";
import { GlobalContext } from "../../context/GlobalContext";
import "./style.css";

export default (props) => {
  const getContextItem = useContext(GlobalContext);
  let {
    get_item_by_category_id,
    imageUrl,
    isLoading,
    itemByCategoryCount,
    itemByCategoryData,
    search_item,
    other_all_item_by_user_id,
    searchText,
    renderSearch,
    user_data,
    loginData,
    changeBySort,
    bySortValue,
    renderListView,
    listView,
  } = getContextItem;

  const propsLocation = useLocation();
  let byUserId = propsLocation.state?.byUserId;
  let categoryData = propsLocation.state?.data;
  const { t } = useTranslation();
  const bySort = [
    { name: t("Sort_By_1"), id: 1 },
    { name: t("Sort_By_2"), id: 2 },
    { name: t("Sort_By_3"), id: 3 },
    { name: t("Sort_By_4"), id: 4 },
  ];

  const [renderHit, setRenderHit] = useState(false);
  const [locationData, setLocationData] = useState({});

  useEffect(() => {
    window.scrollTo(0, 0);
    if (searchText.length) search_item(searchText, bySortValue, locationData);
    else if (byUserId) other_all_item_by_user_id(byUserId, locationData);
    else if (categoryData?.id)
      get_item_by_category_id(categoryData?.id, bySortValue, locationData);
  }, [renderHit]);

  useEffect(() => {
    user_data();
    if (categoryData?.id || byUserId) renderSearch("");
    navigator.geolocation.getCurrentPosition(function (position) {
      setLocationData({
        lat: position.coords.latitude,
        lng: position.coords.longitude,
      });
    });
  }, []);

  return (
    <div>
      {loginData?.id ? (
        <Header
          inPage={true}
          renderHit={() => setRenderHit((prev) => (prev ? false : true))}
        />
      ) : (
        <LoginHeader />
      )}
      <div className="container">
        <div className="row">
          <div className="col-12 mt-3 mb-3">
            <span className="homeHeading">{t("Home")}</span>
            {categoryData?.name ? (
              <span className="arrowStyle">
                {" "}
                <img src={Images.ArrowNew} alt="image" />{" "}
              </span>
            ) : null}
            <span className="pageHeading">{categoryData?.name}</span>
          </div>
        </div>
        {/* <div className="row  my-4 py-4">
          <div className="col-lg-12">
            <div className="rent-search">
              <div className="row">
                <div className="col-lg-2"></div>
                <div className="col-lg-8">
                  <p
                    className="mb-0 dashboard_heading text-center mt-4"
                    style={{ color: "#fff" }}
                  >
                    Rent Cameras in Hong Kong with Elephant Please
                  </p>
                  <p
                    className="mt-2 dashboard-sub text-center"
                    style={{ fontSize: 16, color: "#fff" }}
                  >
                    Rent a Camera from a fellow photographer in Hong Kong. Over
                    50% Cheaper Than Traditional Rental Spend less & Enjoy more
                  </p>
                  <div
                    style={{ width: "80%", margin: "auto" }}
                    class="input-slider input-group mt-2 mb-3"
                  >
                    <input
                      style={{ background: "#fff" }}
                      type="text"
                      class="form-control Montserrat"
                      placeholder="Search Here.."
                      aria-label="Recipient's username"
                      aria-describedby="basic-addon2"
                    />
                    <div class="input-group-append">
                      <Link to="/RentalList">
                        {" "}
                        <button
                          class="bttn  btn-an btn btn-outline-secondary"
                          type="button"
                        >
                          Search
                        </button>
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="col-lg-2"></div>
              </div>
            </div>
          </div>
        </div> */}
        <h5 className="MontserratSemiBold mt-5">
          {t("Browse")} {categoryData?.name}
        </h5>
        <div className="row mt-4">
          <div className="col-lg-6 col-md-6 d-flex m-auto">
            <p className="poppins displaying m-0">
              {t("Displaying")}{" "}
              {itemByCategoryCount.total ? itemByCategoryCount.total : 0}{" "}
              {t("Results")}
            </p>
          </div>
          <div className="col-lg-6 col-md-6 d-flex m-auto justify-content-end">
            <select
              className="list-select Opensans mx-3"
              value={bySortValue}
              onChange={(e) =>
                changeBySort(e.target.value, categoryData, locationData)
              }
            >
              {bySort.map((val) => (
                <option value={val.id}>{val.name}</option>
              ))}
            </select>
            <div className="list-icons-grid">
              <img
                src={listView == 1 ? Images.listFill : Images.list}
                onClick={() => renderListView(1)}
                className="px-2"
              />
              <img
                src={listView == 2 ? Images.gridFill : Images.grid}
                onClick={() => renderListView(2)}
                className="px-2"
              />
              <img
                src={listView == 4 ? Images.locationFill : Images.location}
                onClick={() => renderListView(4, categoryData, locationData)}
                className="px-2"
              />
            </div>
          </div>
        </div>
        <div className="row mt-4">
          {isLoading ? (
            <DotsLoader />
          ) : itemByCategoryData.length ? (
            listView == 1 ? (
              itemByCategoryData?.map((val) => (
                <ProductGridCard
                  data={val}
                  categoryData={categoryData}
                  imageUrl={imageUrl}
                />
              ))
            ) : listView == 2 ? (
              itemByCategoryData?.map((val) => (
                <div className="col-lg-3 col-md-6 col-12">
                  <Link to="/ProductDetail" state={{ item: val, categoryData }}>
                    <ProductCard data={val} imageUrl={imageUrl} />
                  </Link>
                </div>
              ))
            ) : (
              <ProductLocationCard
                data={itemByCategoryData}
                categoryData={categoryData}
                imageUrl={imageUrl}
                locationData={locationData}
              />
            )
          ) : (
            <NoDataFound />
          )}
        </div>
        <div className="row">
          <div className="col-lg-12 text-center">
            <RenderPagination />
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};
